const isEmpty = (val: any) => {
  return val === null || val === undefined || val === '' || isEmptyArray(val)
}
const isEmptyArray = (val: any) => {
  return Array.isArray(val) && val.length === 0
}

export default {
  isEmpty,
  isEmptyArray
}
